export default "__VITE_ASSET__B7e5U9r3__"